export function getTypes() {
    return [
        { id: "Pública", name: "Pública" },
        { id: "Privada", name: "Privada" },
        { id: "Militar", name: "Militar" }
    ]
}

